<template>
  <div>
    <div class="row rowSegments mt-4 mb-5 justify-content-md-center ">
        <div class="col-md-10">
           <p class="boxTitleIntro mt-3">Audience</p>
            <div class="row mt-5 mb-5 graphicsBlock">
              <div class="titleBlock">
                <strong>MAIN METRICS</strong><br/>
                <small>Top metrics from your audience</small>
              </div>
              <div class="insightsBlock">
                Insights  <img style="height: 20px;" src="img/site/lamp.png"/>
              </div>
              <div class="col-md-3" style="padding: 10px;">
                    <CCallout color="warning" style="max-height: 100px; border-top: 1px solid #e8eaec; border-bottom: 1px solid #e8eaec; border-right: 1px solid #e8eaec;">
                      <div class="row">
                        <div class="col-5" style="padding-left: 11px; padding-right: 0px; padding-top: 15px;">
                          <small class="text-muted" style="font-size: 10px;">TOTAL CONTACTS</small><br>
                          <strong class="h5" style="font-size: 1.3rem;">9,123</strong>
                        </div>
                        <div class="col-7" style="padding-top: 20px; padding-bottom: 20px;">
                          <CChartLine style="max-height: 50px;" :datasets="computedDatasetsLine1" :options="computedOptions" :labels="labels" />
                        </div>
                      </div>
                    </CCallout>
              </div>
              <div class="col-md-3" style="padding: 10px;">
                    <CCallout color="info" style="max-height: 100px; border-top: 1px solid #e8eaec; border-bottom: 1px solid #e8eaec; border-right: 1px solid #e8eaec;">
                      <div class="row">
                        <div class="col-5" style="padding-left: 11px; padding-right: 0px; padding-top: 15px;">
                          <small class="text-muted" style="font-size: 10px;">NEW CONTACTS</small><br>
                          <strong class="h5" style="font-size: 1.3rem;">9,123</strong>
                        </div>
                        <div class="col-7" style="padding-top: 20px; padding-bottom: 20px;">
                          <CChartLine style="max-height: 50px;" :datasets="computedDatasetsLine2" :options="computedOptions" :labels="labels" />
                        </div>
                      </div>
                    </CCallout>
              </div>
              <div class="col-md-3" style="padding: 10px;">
                    <CCallout color="success" style="max-height: 100px; border-top: 1px solid #e8eaec; border-bottom: 1px solid #e8eaec; border-right: 1px solid #e8eaec;">
                      <div class="row">
                        <div class="col-5" style="padding-left: 11px; padding-right: 0px; padding-top: 15px;">
                          <small class="text-muted" style="font-size: 10px;">MESSAGES SENT</small><br>
                          <strong class="h5" style="font-size: 1.3rem;">9,123</strong>
                        </div>
                        <div class="col-7" style="padding-top: 20px; padding-bottom: 20px;">
                          <CChartLine style="max-height: 50px;" :datasets="computedDatasetsLine3" :options="computedOptions" :labels="labels" />
                        </div>
                      </div>
                    </CCallout>
              </div>
              <div class="col-md-3" style="padding: 10px;">
                    <CCallout color="danger" style="max-height: 100px; border-top: 1px solid #e8eaec; border-bottom: 1px solid #e8eaec; border-right: 1px solid #e8eaec;">
                      <div class="row">
                        <div class="col-5" style="padding-left: 11px; padding-right: 0px; padding-top: 15px;">
                          <small class="text-muted" style="font-size: 10px;">UNSUBSCRIBED</small><br>
                          <strong class="h5" style="font-size: 1.3rem;">9,123</strong>
                        </div>
                        <div class="col-7" style="padding-top: 20px; padding-bottom: 20px;">
                          <CChartLine style="max-height: 50px;" :datasets="computedDatasetsLine4" :options="computedOptions" :labels="labels" />
                        </div>
                      </div>
                    </CCallout>
              </div>
            </div>
            <div class="row mt-5 mb-5 graphicsBlock">
                <div class="titleBlock">
                  <strong>GROWTH</strong><br/>
                  <small>How is your audience growing?</small>
                </div>
                <div class="insightsBlock">
                  Insights  <img style="height: 20px;" src="img/site/lamp.png"/>
                </div>
                <CChartLine
                  :datasets="defaultDatasetsGrowth"
                  labels="months"
                  style="width: 100%;"
                />
            </div>
            <div class="row mt-5 mb-5 pt-5 graphicsBlock">
                <div class="titleBlock">
                  <strong>SOURCES</strong><br/>
                  <small>Where are your contacts coming from?</small>
                </div>
                <div class="insightsBlock">
                  Insights  <img style="height: 20px;" src="img/site/lamp.png"/>
                </div>
                <CChartDoughnut :datasets="defaultDatasetsDoughnut" style="width: 40%;" />

                <!-- PROGRESS -->
                <div class="boxRightProgressBar mt-3" style="width: 55%;">
                    <div class="progress-group mt-2">
                          <div class="progress-group-header">
                            <span class="title title-progress ">Website from subscribers</span>
                            <span class="ml-auto  title-progress">123,675 (56%)</span>
                          </div>
                          <div class="progress-group-bars">
                            <div class="progress progress-custom">
                                <div class="progress-bar bg-orange-progress" role="progressbar" style="width: 56%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                    </div>
                    <div class="progress-group">
                          <div class="progress-group-header">
                            <span class="title title-progress">Facebook lead ads</span>
                            <span class="ml-auto  title-progress">23,675 (25%)</span>
                          </div>
                          <div class="progress-group-bars">
                            <div class="progress progress-custom">
                                <div class="progress-bar bg-green-progress" role="progressbar" style="width: 25%; background-color: #6aa765;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                    </div>
                    <div class="progress-group">
                          <div class="progress-group-header">
                            <span class="title title-progress">XLS import</span>
                            <span class="ml-auto  title-progress">230,675 (75%)</span>
                          </div>
                          <div class="progress-group-bars">
                            <div class="progress progress-custom">
                                <div class="progress-bar bg-blue-progress" role="progressbar" style="width: 75%; background-color: #00aff0;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                    </div>
                    <div class="progress-group">
                          <div class="progress-group-header">
                            <span class="title title-progress">Linkedin lead ads</span>
                            <span class="ml-auto  title-progress">36,675 (37%)</span>
                          </div>
                          <div class="progress-group-bars">
                            <div class="progress progress-custom">
                                <div class="progress-bar bg-orange-progress" role="progressbar" style="width: 37%; background-color: #ffc107;" aria-valuenow="37" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                    </div>
                </div>
                <!-- END PROGRESS -->
            </div>
            <div class="row mt-5 mb-5 pt-5 graphicsBlock">
                <div class="titleBlock">
                  <strong>REVENUES</strong><br/>
                  <small>Revenues that your audience is generating</small>
                </div>
                <div class="insightsBlock">
                  Insights  <img style="height: 20px;" src="img/site/lamp.png"/>
                </div>
                <div class="col-md-6">
                  <CChartPie :datasets="defaultDatasetsPie" />
                </div>
                <div class="col-md-6">
                  <CChartDoughnut :datasets="defaultDatasetsDoughnut" />
                </div>
                <div class="col-md-12 mt-5">
                  <CChartLine
                    :datasets="defaultDatasetsRevenues"
                    labels="months"
                    style="width: 100%;"
                  />
                </div>
            </div>



            <div class="row mt-5 mb-5 pt-5 graphicsBlock">
                <div class="titleBlock">
                  <strong>DEMOGRAPHICS</strong><br/>
                  <small>Who is your audience?</small>
                </div>
                <div class="insightsBlock">
                  Insights  <img style="height: 20px;" src="img/site/lamp.png"/>
                </div>
                <div style="width: 60%;">
                  <CChartBar :datasets="defaultDatasetsDemographics" :labels="labelsDemographics" :options="optionsDemographics" />
                </div>
                <div style="width: 40%;">
                    <div class="progress-group mt-2" style="padding-left: 15%; padding-right: 15%;">
                          <div class="progress-group-header">
                            <span class="title title-progress ">Male</span>
                            <span class="ml-auto  title-progress">50%</span>
                          </div>
                          <div class="progress-group-bars">
                            <div class="progress progress-custom">
                                <div class="progress-bar bg-orange-progress" role="progressbar" style="width: 50%; background-color: #ffc107;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                    </div>
                    <div class="progress-group mt-2" style="padding-left: 15%; padding-right: 15%;">
                          <div class="progress-group-header">
                            <span class="title title-progress ">Female</span>
                            <span class="ml-auto  title-progress">50%</span>
                          </div>
                          <div class="progress-group-bars">
                            <div class="progress progress-custom">
                                <div class="progress-bar bg-orange-progress" role="progressbar" style="width: 50%; " aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                    </div>
                  <CChartDoughnut :datasets="defaultDatasetsDoughnutDemographics" style="width: 100%;" />
                </div>
            </div>
            <!-- <div class="row mt-5 mb-5 pt-5 graphicsBlock">
                <div class="titleBlock">
                  <strong>ENGAGEMENT</strong><br/>
                  <small>How are your channels performing?</small>
                </div>
                <div class="insightsBlock">
                  Insights  <img style="height: 20px;" src="img/site/lamp.png"/>
                </div>
                <div style="60%">
                  <div class="row">

                    <div class="col">
                      <div class="progressCircle progress blue">
                        <span class="progressCircle-left progress-left">
                            <span class="progressCircle-bar progress-bar"></span>
                        </span>
                        <span class="progressCircle-right progress-right">
                            <span class="progressCircle-bar progress-bar"></span>
                        </span>
                        <div class="progressCircle-value progress-value">5% CTR</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="40%"></div>
            </div> -->
        </div>

    </div>
  </div>
</template>

<script>

import { CChartPie, CChartDoughnut, CChartLine, CChartBar } from '@coreui/vue-chartjs'
import { getColor, deepObjectsMerge } from '@coreui/utils/src'

export default {
  name: 'AudienceDashboard',
  components: {
    CChartPie,
    CChartDoughnut,
    CChartLine,
    CChartBar
  },
  props: {
    ...CChartLine.props,
    borderColor: {
      type: String,
      default: 'rgba(247, 143, 88,.55)'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    dataPoints: {
      type: Array,
      default: () => [10, 22, 34, 46, 58, 65, 46, 23, 45, 58, 34, 12]
    },
    label: {
      type: String,
      default: 'Contacts'
    },
    pointed: Boolean,
    pointHoverBackgroundColor: String
  },
  data () {
    return {
      labelsDemographics: ['18-25', '26-35', '36-45', '46-55', '+56'],
      optionsDemographics: {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
      }
    }
  },
  methods: {

  },
  computed: {
    defaultDatasetsPie () {
      return [
        {
          backgroundColor: [
            '#f78f58',
            '#ffc107',
            '#00aff0',
            '#6aa765'
          ],
          data: [40, 20, 30, 20]
        }
      ]
    },
    defaultDatasetsDoughnut () {
      return [
        {
          backgroundColor: [
            '#f78f58',
            '#ffc107',
            '#00aff0',
            '#6aa765'
          ],
          data: [40, 20, 30, 20]
        }
      ]
    },
    defaultDatasetsDoughnutDemographics () {
      return [
        {
          backgroundColor: [
            '#f78f58',
            '#ffc107'
          ],
          data: [40, 60]
        }
      ]
    },
    pointHoverColor () {
      if (this.pointHoverBackgroundColor) {
        return this.pointHoverBackgroundColor
      } else if (this.backgroundColor !== 'transparent') {
        return this.backgroundColor
      }
      return this.borderColor
    },
    defaultDatasetsLine1 () {
      return [
        {
          data: this.dataPoints,
          borderColor: getColor(this.borderColor),
          backgroundColor: getColor(this.backgroundColor),
          pointBackgroundColor: getColor(this.pointHoverColor),
          pointHoverBackgroundColor: getColor(this.pointHoverColor),
          label: this.label
        }
      ]
    },
    defaultDatasetsLine2 () {
      return [
        {
          data: this.dataPoints,
          borderColor: '#00aff0',
          backgroundColor: getColor(this.backgroundColor),
          pointBackgroundColor: getColor(this.pointHoverColor),
          pointHoverBackgroundColor: getColor(this.pointHoverColor),
          label: this.label
        }
      ]
    },
    defaultDatasetsLine3 () {
      return [
        {
          data: this.dataPoints,
          borderColor: '#6aa765',
          backgroundColor: getColor(this.backgroundColor),
          pointBackgroundColor: getColor(this.pointHoverColor),
          pointHoverBackgroundColor: getColor(this.pointHoverColor),
          label: this.label
        }
      ]
    },
    defaultDatasetsLine4 () {
      return [
        {
          data: this.dataPoints,
          borderColor: '#b60f0f',
          backgroundColor: getColor(this.backgroundColor),
          pointBackgroundColor: getColor(this.pointHoverColor),
          pointHoverBackgroundColor: getColor(this.pointHoverColor),
          label: this.label
        }
      ]
    },
    pointedOptions () {
      return {
        scales: {
          xAxes: [
            {
              offset: true,
              gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
              },
              ticks: {
                fontSize: 2,
                fontColor: 'transparent'
              }
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                display: false,
                min: Math.min.apply(Math, this.dataPoints) - 5,
                max: Math.max.apply(Math, this.dataPoints) + 5
              }
            }
          ]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4
          }
        }
      }
    },
    straightOptions () {
      return {
        scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: false
          }]
        },
        elements: {
          line: {
            borderWidth: 2
          },
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4
          }
        }
      }
    },
    defaultOptions () {
      const options = this.pointed ? this.pointedOptions : this.straightOptions
      return Object.assign({}, options, {
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      })
    },
    computedDatasetsLine1 () {
      return deepObjectsMerge(this.defaultDatasetsLine1, this.datasets || {})
    },
    computedDatasetsLine2 () {
      return deepObjectsMerge(this.defaultDatasetsLine2, this.datasets || {})
    },
    computedDatasetsLine3 () {
      return deepObjectsMerge(this.defaultDatasetsLine3, this.datasets || {})
    },
    computedDatasetsLine4 () {
      return deepObjectsMerge(this.defaultDatasetsLine4, this.datasets || {})
    },
    computedOptions () {
      return deepObjectsMerge(this.defaultOptions, this.options || {})
    },
    defaultDatasetsGrowth () {
      return [
        {
          label: 'New Contactos',
          backgroundColor: 'rgb(106, 167, 101, 0.7)',
          data: [30, 45, 35, 30, 35, 35, 40]
        },
        {
          label: 'Existing',
          backgroundColor: '#cceffc',
          data: [39, 50, 40, 35, 40, 40, 45]
        }
      ]
    },
    defaultDatasetsRevenues () {
      return [
        {
          label: 'Male',
          backgroundColor: 'rgb(106, 167, 101, 0.7)',
          data: [30, 45, 35, 30, 35, 35, 40]
        },
        {
          label: 'Female',
          backgroundColor: '#cceffc',
          data: [39, 50, 40, 35, 40, 40, 45]
        }
      ]
    },
    defaultDatasetsDemographics () {
      return [
        {
          label: 'Male',
          backgroundColor: '#ffc107',
          data: [40, 20, 12, 39, 10]
        },
        {
          label: 'Female',
          backgroundColor: '#f78f58',
          data: [30, 10, 6, 15, 5]
        }
      ]
    },
  }
}
</script>
